import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'dayjs/locale/zh-cn'
import locale from "element-plus/es/locale/lang/zh-cn"
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import axios from 'axios'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(ElementPlus, { locale })
  .use(ElementPlusIconsVue)
  .use(pinia)
app.config.globalProperties.$axios = axios
Object.keys(ElementPlusIconsVue).forEach(key => {
  app.component(ElementPlusIconsVue[key].name, ElementPlusIconsVue[key])
})

import mitt from 'mitt'

app.config.globalProperties.Bus = mitt()
// import { useUserStore } from '@/store/counter'
// async function initializeStore() {
//   await useUserStore().initializeStore();
// }
// initializeStore().then(() => {
// 应用挂载
app.use(router).mount('#app')
// })